import type { ReactElement } from 'react';
import { AddClient } from './clients/AddClient';
import { ClientList } from './clients/ClientList';
import { AddUser } from './users/AddUser';
import { UsersList } from './users/UsersList';

/** Ported screens of this slice, keyed by their Angular URL (see src/app/routeManifest.ts). */
export const screens: Record<string, ReactElement> = {
  '/home/manage/clients': <ClientList />,
  '/home/manage/addClient': <AddClient />,
  '/home/manage/users': <UsersList />,
  '/home/manage/addUser': <AddUser />,
};
